export default [{
  path: '/view/companytime',
  name: 'companytime',
  component: () => import('@/app/company-time/CompanyTime'),
  meta: {
    resource: 'companytime',
    actions: ['read']
  }
}]
